import {create, createStore} from 'zustand';
import {DashboardTypes} from '../../../../../shared/types/dashboard.types';

interface DashboardTypeStore {
  dashboardType: DashboardTypes;

  setDashboardType: (type: DashboardTypes) => void;
}

export const useDashboardTypeStore = create<DashboardTypeStore>((set) => ({
  dashboardType: DashboardTypes.REQUESTS_MOVE,

  setDashboardType: (dashboardType) => set({dashboardType}),
}));

export const createDashboardTypeStore = () =>
  createStore<DashboardTypeStore>((set) => ({
    dashboardType: DashboardTypes.REQUESTS_MOVE,

    setDashboardType: (dashboardType) => set({dashboardType}),
  }));
